import { render, staticRenderFns } from "./FINGLReport.vue?vue&type=template&id=204d2163&scoped=true&"
import script from "./FINGLReport.vue?vue&type=script&lang=js&"
export * from "./FINGLReport.vue?vue&type=script&lang=js&"
import style0 from "./FINGLReport.vue?vue&type=style&index=0&id=204d2163&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204d2163",
  null
  
)

export default component.exports